export default {
    en: {
        id: 'diagram4b2-6',
        blocks: [
            {
                index: '1',
                task: 'S = Tv viewing is down by 6.4% and 3.1% ',
                title: "S = "
            },
            {
                index: '2',
                task: 'C =Translates into millions of people ',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = What can millions being doing instead?',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '3',
                title: 'Why happen?'
            },
            {
                index: '1',
                title: 'X has occurred'
            },
            {
                index: '2',
                title: 'Is a major change'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 4,
        note: `
        This is the most straightforward way to read this introduction. But many people believe that (a) the Situation and the Complication as stated say the same thing, and therefore the Situation is implied. Still others say, no, the Complication is implied.
        Here are the other two ways you could read it.
        <div class="scq__note-title">Situation Implied</div>
        <div class="scq__note">
            <div>
                S = (People used to watch TV all the time)
                C = Have stopped watching
                Q = What doing instead?
            </div>
            <div>
                S = Stopped doing X
                C = Must be doing non-X
                Q = What is non-X?
            </div>
        </div>
        <div class="scq__note-title">Complication Implied</div>
        <div class="scq__note">
            <div>
                S = People have stopped doing X
                C = (Must be doing something else)
                Q = What doing ?
            </div>
            <div>
                S = Stopped doing X
                C = Clearly doing something else
                Q = What is it?
            </div>
        </div>

        `
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise6.js